module.exports = __webpack_public_path__ + "img/dbd5de9.png";